// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DHHW","col":"styles_col__3Lt3K"};